import logoInitial from "../../assets/png/Netuno_Logo_dark.png";
import { textRecover, textlogin } from "../../locales/es-es";
import { useForm } from "../../Hooks/UseForm";
import { Link } from "react-router-dom";
import { initialRecover } from "../../propsType/RecoverPassword";
import { validationRecover } from "../../validations/formValidations";
import ButtonGeneric from "../../components/Buttons/ButtonGeneric";
import InputGeneric from "../../components/Inputs/InputGeneric";
import { colors } from "../../propsType/Colors";
import { optionLogin } from "../../propsType/SignUp";
import SelectGeneric from "../../components/Inputs/SelectGeneric";
import { useEffect, useState } from "react";
import Spinner from "../../components/Loading/loadingSpinner/Spinner";
import AuthController from "../../controllers/AuthController";
import Modal from "../../components/Modals/Modal";
import { extrac } from "../../helpers/selectForm";

const RecoverPassword = () => {
  const [loading, setLoading] = useState(false);
  const [loadinButton, setLoadinButton] = useState(false);
  const [validateState, setValidateState] = useState(false);
  const [correos, setCorreos] = useState([]);
  const [activeModal, setActiveModal] = useState(false);
  const [activeButton, setActiveButton] = useState(false);
  const [check, setCheck] = useState(false);
  const [message, setMessage] = useState("");



  const { form, errors, handleChange, handleSubmit, handleBlur } = useForm(
    initialRecover,
    validationRecover,
    validateState
  );
  const { registerDoc, recoverEmail } = AuthController();

  function filtro(e) {
    if (form.selectDoc !== "Pasaporte"){
    var tecla = e.key;
    if (['.', 'e','E' ].includes(tecla))
      e.preventDefault()}
  }
 
  const validatePassword = async () => {
    const result = handleSubmit();
    if (result === "ok") {

      const { typeDoc, selectDoc } = form;

      const result = extrac(selectDoc);
      let newObjet = {
        tipoDoc: result,
        id: typeDoc,
      };

      setLoadinButton(true);
      const data = await registerDoc(newObjet);
   
      if (data.statusCuenta === "8")
      {
        setCheck(false);
        setLoading(false);
        setActiveModal(true);
        setMessage("No podemos encontrar ningún usuario con esa identificación.");
        setActiveButton(false);
        setLoadinButton(false);
        form.selectDoc= "";
        form.typeDoc = "";
        setValidateState(false);
      }

      if (data.status === -1 && data.correos.length > 0 && data.statusCuenta !== "8") 
      {
        setCorreos(data.correos);
        setLoadinButton(false);
        setValidateState(true);
      }
      else if (data.status === -1 && data.correos.length === 0) {
        setCheck(false);
        setLoading(false);
        setActiveModal(true);
        setMessage("No tienes un correo electrónico asociado en tu cuenta. Contáctanos a través de nuestros diferentes medios de contacto para actualizar tus datos.");
        setActiveButton(false);
        setLoadinButton(false);
        setValidateState(false);
      }
      else {
        setCheck(false);
        setLoading(false);
        setActiveModal(true);
        setMessage("No podemos encontrar ningún usuario con esa identificación.");
        setActiveButton(false);
        setLoadinButton(false);
        setValidateState(false);
      }
    }
  };
  const sendLogin = async () => {
     
    const result = handleSubmit();
    if (result === "ok" && form.selectCorreo === "") {console.log ("No pase")}
    if (result === "ok" && form.selectCorreo !== "") {
      setLoading(true);
      let oneCorreo = JSON.parse(form.selectCorreo);
      await recoverEmail({ email: oneCorreo.id }).then((data) => {

      /*let oneCorreo = JSON.parse(form.selectCorreo);
      const { typeDoc } = form;

      const clienteUrl = oneCorreo.id + "netuno" + typeDoc;

      await recoverEmail({ email: clienteUrl }).then((data) => {*/

        if (data.respuesta === "0") {
          setLoading(false);
          setActiveModal(true);
          setCheck(true);
          setMessage(data.descripcion);
          setActiveButton(true);
        } else {
          setCheck(false);
          setLoading(false);
          setActiveModal(true);
          setMessage(data.descripcion);
          setActiveButton(false);
        }
      });
    }
  };
  const closetModal = () => {
    setActiveModal(false);
    setMessage("");
    if (activeButton) {
      /*   setErrors('') */
    }
  };
  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  return (
    <>
      <div className="h-screen  lg:flex">
        <div className="flex-1  flex flex-col w-auto lg:w-[44%] h-screen py-4 xl:overflow-hidden justify-center  px-4 sm:px-6 md:flex-none lg:px-0 xl:px-0">
          {loading ? (
            <>
              <Spinner title={"Espere..."} />
            </>
          ) : (
            <>
              <div className="mx-auto w-full  md:max-w-sm overflow-y-auto  lg:mt-0 px-4 xl:max-w-lg xl:w-[32rem]">
                <div>
                  <img
                    className="h-12 w-auto"
                    src={logoInitial}
                    alt="Workflow"
                  />
                  <h2 className="mt-6 mb-2 text-3xl font-extrabold text-gray-900">
                    {" "}
                    {textRecover.ingresar}{" "}
                  </h2>
                  <p
                    className={`text-sm font-medium text-[${colors.lightBlue}]`}
                  >
                    {textRecover.acceder}{" "}
                  </p>
                </div>

                <div className="mt-8">
                  <div className="mt-6">
                    <div className="grid  gap-3">
                      <div className="text-sm !mb-[-0.50rem] font-medium text-gray-900">
                        {" "}
                        {textlogin.doc}
                      </div>
                      <div className="grid grid-cols-7">
                        <div className="col-span-2">
                          <SelectGeneric
                            onChange={handleChange}
                            value={form?.selectDoc}
                            name={"selectDoc"}
                            onBlur={handleBlur}
                            errors={errors?.selectDoc}
                            selectData={optionLogin}
                          />
                        </div>
                        <div className="col-span-5">
                          <InputGeneric
                            name={"typeDoc"}
                            type={form?.selectDoc === "Pasaporte" ? "text" : "number"}
                            onBlur={handleBlur}
                            value={form?.typeDoc}
                            onChange={handleChange}
                            handleBlur={handleBlur}
                            errorText={errors?.typeDoc}
                            onKeyDown={(e) => filtro(e)}
                            maxValue={13}
                          />
                        </div>
                      </div>
                      <ButtonGeneric
                        text={"Validar Datos"}
                        loading={loadinButton}
                        funtion={validatePassword}
                      />
                      <div className=" relative">
                        <div
                          className="absolute inset-0 flex items-center"
                          aria-hidden="true"
                        >
                          <div className="w-full border-t border-gray-300" />
                        </div>
                        <div className="relative flex justify-center text-sm"></div>
                      </div>
                    </div>

                    <div className="space-y-6 mt-5">
                      {validateState && (
                        <>
                          <SelectGeneric
                            onChange={handleChange}
                            value={form?.selectCorreo}
                            name={"selectCorreo"}
                            onBlur={handleBlur}
                            errors={errors?.selectCorreo}
                            disabled={!validateState}
                            selectData={correos}
                          />
                          <div>
                            <ButtonGeneric
                              funtion={sendLogin}
                              bgButton={colors.darkBlue}
                              text={"Enviar Enlace para Restablecer Contraseña"}
                            />
                          </div>
                        </>
                      )}

                      <div className="flex items-center justify-between">
                        <div className="flex items-center"></div>
                        <div className="text-sm">
                          <Link
                            to={"/cuenta"}
                            className={`font-medium capitalize text-[${colors.darkBlue}] hover:text-[${colors.darkBlue}]`}
                          >
                            {textRecover.volver}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <div
          className={`hidden bg-[url("../public/banner.jpg")] border-[${colors.darkBlue}] border-l-4 bg-cover bg-center bg-no-repeat lg:block relative w-0 flex-1`}
        ></div>
      </div>

      <Modal
        string={check ? "check" : "error"}
        message={message}
        active={activeModal}
        setActive={setActiveModal}
      >
        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
          <div className="flex  flex-col gap-2 ">
            <button
              type="button"
              onClick={(e) => {
                closetModal()
                (check ? window.location.href = '/cuenta' : closetModal())
              }}
              className={` ${check ? "bg-green-500" : "bg-red-500"
                } inline-flex w-full justify-center rounded-md  px-3 py-2 text-sm font-semibold text-white shadow-sm  sm:ml-3 sm:w-auto`}
            >
              Cerrar
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default RecoverPassword;
